import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

// @material-ui/core
import { makeStyles } from "@mui/styles";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Grid } from "@mui/material";

import backgroundImg from "assets/img/fondo-seccion-vehicular.webp";
//import logoConfident from "assets/img/pin_confident.png";

import TransactionsListDashboard from "views/Admin/TransactionsListDashboard";

import {
  dashboardStyle,
  ButtonStyleWhite0,
} from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(dashboardStyle);

export default function Dashboard() {
  const classes = useStyles();

  const [buttonRegisterClients, setRegisterClients] = useState(false);
  const [buttonClients, setButtonClients] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (buttonRegisterClients) {
    localStorage.setItem("controllerRouter", "/customers/client-register");
    return <Redirect to="/customers/client-register" />;
  }

  if (buttonClients) {
    localStorage.setItem("controllerRouter", "/customers/clients");
    return <Redirect to="/customers/clients" />;
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} md={12}>
          <div className={classes.carDashboard}>
            <Grid
              container
              spacing={1}
              sx={{
                padding: 3,
                backgroundImage: `url(${backgroundImg})`,
                height: 200,
              }}
            >
              <Grid item xs={12} sm={12}>
                <b style={{ color: "#202C59", fontSize: 42 }}>Somos Úsame</b>
                <div style={{ color: "#202C59", fontSize: 18, marginTop: 18 }}>
                  El Marketplace de servicios más completo de Ecuador Nacemos
                  para hacer tu vida más fácil.
                </div>
              </Grid>
              <Grid item xs={12} sm={7}>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    margin: "4px 0 0 10px",
                  }}
                >
                  <Grid item xs={12} sm={6}>
                    <ButtonStyleWhite0
                      style={{ fontSize: 14, width: 220 }}
                      onClick={() => setRegisterClients(true)}
                    >
                      Nueva solicitud a cliente
                    </ButtonStyleWhite0>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <ButtonStyleWhite0
                      style={{ fontSize: 14, width: 190 }}
                      onClick={() => setButtonClients(true)}
                    >
                      Listado de clientes
                    </ButtonStyleWhite0>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </GridItem>
        <GridItem item xs={12} md={12} sx={{ mt: "-20px" }}>
          <TransactionsListDashboard />
        </GridItem>
      </GridContainer>
    </div>
  );
}
